// lib/api-config.ts

export interface ServerVariable {
  name: string;
  value: string;
  type: 'header' | 'parameter' | 'body';
}

export interface ServerConfiguration {
  serverUrl: string;
  variables: ServerVariable[];
}

export interface APISettings {
  team: string;
  project: string;
  MIAproject: string;
  MIAprojectShort: string;
  apiPortal: boolean;
  mcp: boolean;
  mcpUrl?: string;
  throttlingRate?: number;
  throttlingBurst?: number;
  Quota: number;
  QuotaPeriod: string;
  userManagement: boolean;
  userGroup: string;
  useApiKeys: boolean;
  useCustomOAuth?: boolean;
  oauthSettings: {
    clientId: string;
    clientSecret: string;
    domain: string;
    provider?: string;
    scopes?: string[];
    allowedCallbackUrls: string[];
    allowedLogoutUrls: string[];
    allowedOriginUrls: string[];
  };
  automatedReleaseToAll?: boolean;
  specificStageReleaseTarget?: string;
  serverConfigurations?: ServerConfiguration[];
}

export const DEFAULT_API_SETTINGS: APISettings = {
  team: '',
  project: '',
  MIAproject: '',
  MIAprojectShort: '',
  apiPortal: false,
  mcp: true,
  mcpUrl: '',
  userManagement: true,
  userGroup: 'usergroup1',
  useApiKeys: true,
  Quota: 1000,
  QuotaPeriod: 'day',
  useCustomOAuth: false,
  oauthSettings: {
    clientId: '',
    clientSecret: '',
    domain: 'https://',
    provider: 'others',
    scopes: [],
    allowedCallbackUrls: [],
    allowedLogoutUrls: [],
    allowedOriginUrls: []
  },
  throttlingRate: 1000,
  throttlingBurst: 1000,
  serverConfigurations: []
} as const;
